module.exports = __webpack_public_path__ + "static/media/ignoto.046e6a0c.gif";